import { render, staticRenderFns } from "./StudySearch.vue?vue&type=template&id=76cd4e78&scoped=true"
import script from "./StudySearch.vue?vue&type=script&lang=js"
export * from "./StudySearch.vue?vue&type=script&lang=js"
import style0 from "./StudySearch.vue?vue&type=style&index=0&id=76cd4e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cd4e78",
  null
  
)

export default component.exports